<template>
    <div>
        <v-container class="grey lighten-5" fluid>
           <v-row v-if="companyDetails && Object.entries(companyDetails).length">
                <v-col cols="12">
                    <v-card>
                      <v-tabs v-model="tab">
                        <v-tab>
                          Dane firmy
                        </v-tab>
                        <v-tab>
                          Historia handlu
                        </v-tab>
                        <v-tab>
                          Obsługiwane kategorie
                        </v-tab>
                        <v-tab>
                          BDO
                        </v-tab>
                        <v-tab>
                          Wysłane wiadomości
                        </v-tab>
                        <v-tab>
                          Dokumenty
                        </v-tab>
                      </v-tabs>
                      <v-tabs-items v-model="tab">
                        <v-tab-item>
                          <v-card class="mb-2">
                            <v-card-text>
                              <v-btn v-if="companyDetails.plcId" @click="$router.push({name: 'price-list-company-details', params: { id: companyDetails.plcId }})">przejdź do firmy w module cennikowym</v-btn>
                              <v-form ref="companyDetailsForm">
                                <v-row>
                                  <v-col cols="12" sm="6" lg="3">
                                    <v-select
                                        v-model="companyDetails.type"
                                        :items="types"
                                        item-text="text"
                                        item-value="value"
                                        class="pt-0"
                                        label="Typ"
                                    ></v-select>
                                  </v-col>
                                  <v-col cols="12" sm="6" lg="3">
                                    <v-text-field
                                        v-model="companyDetails.name"
                                        class="pt-0"
                                        label="Nazwa"
                                        placeholder=" "
                                        :counter="100"
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="12" sm="6" lg="3">
                                    <v-text-field
                                        v-model="companyDetails.email"
                                        class="pt-0"
                                        label="E-mail"
                                        placeholder=" "
                                        :rules="rules.email"
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="12" sm="6" lg="3">
                                    <v-text-field
                                        v-model="companyDetails.nip"
                                        class="pt-0"
                                        label="NIP"
                                        placeholder=" "
                                        :rules="rules.nip"
                                        :counter="10"
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col cols="12" lg="4">
                                    <v-text-field
                                        v-model="companyDetails.address.address"
                                        class="pt-0"
                                        label="Ulica"
                                        placeholder=" "
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="12" sm="3" lg="2">
                                    <v-text-field
                                        v-model="companyDetails.address.city"
                                        class="pt-0"
                                        label="Miejscowość"
                                        placeholder=" "
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="12" sm="3" lg="2">
                                    <v-text-field
                                        v-model="companyDetails.address.postalCode"
                                        class="pt-0"
                                        label="Kod pocztowy"
                                        placeholder=" "
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="12" sm="3" lg="2">
                                    <v-select
                                        v-model="companyDetails.address.region"
                                        :items="regions"
                                        item-text="value"
                                        item-value="key"
                                        class="pt-0"
                                        label="Województwo"
                                    ></v-select>
                                  </v-col>
                                  <v-col cols="12" sm="3" lg="2">
                                    <v-text-field
                                        v-model="companyDetails.address.country"
                                        class="pt-0"
                                        label="Kraj"
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col cols="12" sm="4" md="2">
                                    <v-text-field
                                        v-model="companyDetails.rating"
                                        class="pt-0"
                                        label="Rating"
                                        placeholder=" "
                                        readonly
                                        disabled
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="12" sm="4" md="2">
                                    <v-text-field
                                        v-model="companyDetails.bdo"
                                        class="pt-0"
                                        label="Numer BDO"
                                        placeholder=" "
                                        :rules="rules.bdo"
                                        :counter="20"
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="6" sm="4" md="2">
                                    <div class="pb-0 disabled-label">
                                      Abonament BDO:
                                    </div>
                                    <v-switch
                                        v-model="companyDetails.bdoSubscription"
                                        class="mt-0 pt-0"
                                        :label="companyDetails.bdoSubscription ? 'Tak' : 'Nie'"
                                    ></v-switch>
                                  </v-col>
                                  <v-col cols="6" sm="4" md="2">
                                    <div class="pb-0 disabled-label">
                                      Aktywna:
                                    </div>
                                    <v-switch
                                        v-model="companyDetails.active"
                                        class="mt-0 pt-0"
                                        :label="companyDetails.active ? 'Tak' : 'Nie'"
                                    ></v-switch>
                                  </v-col>
                                  <v-col cols="12" md="2">
                                    <v-text-field
                                        v-model="companyDetails.email"
                                        class="pt-0"
                                        label="Oficjalny email"
                                        placeholder=" "
                                        disabled
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="12" sm="6" md="2">
                                    <v-select
                                        v-model="companyDetails.confirmed"
                                        :items="statuses"
                                        item-text="text"
                                        item-value="value"
                                        class="mt-0 pt-0"
                                        label="Status"
                                        readonly
                                        disabled
                                    ></v-select>
                                  </v-col>
                                  <v-col cols="6" sm="3" md="1">
                                    <div class="pb-0 disabled-label">
                                      Premium:
                                    </div>
                                    <v-switch
                                        v-model="companyDetails.premium"
                                        class="mt-0 pt-0"
                                        :label="companyDetails.premium ? 'Tak' : 'Nie'"
                                        readonly
                                        disabled
                                    ></v-switch>
                                  </v-col>
                                  <v-col cols="6" sm="3" md="1">
                                    <div class="pb-0 disabled-label" style="color: rgba(0, 0, 0, 0.6)">
                                      Partner:
                                    </div>
                                    <v-switch
                                        v-model="companyDetails.partner"
                                        class="mt-0 pt-0"
                                        :label="companyDetails.partner ? 'Tak' : 'Nie'"
                                    ></v-switch>
                                  </v-col>
                                  <v-col cols="12">
                                    <v-text-field
                                        v-model="companyDetails.points"
                                        type="number"
                                        min="0"
                                        step="1"
                                        class="pt-0"
                                        label="Ilość punktów"
                                        placeholder=" "
                                    />
                                  </v-col>
                                </v-row>
                              </v-form>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer />
                              <v-btn
                                  @click="saveCompanyDetails"
                              >
                                Zapisz
                                <v-icon size="24" right>
                                  mdi-content-save-outline
                                </v-icon>
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                          <v-card :color="rawCompanyDetails.supervisor ? rawCompanyDetails.supervisor.color : ''">
                            <v-card-text>
                              <v-autocomplete
                                  v-model="companyDetails.supervisor"
                                  :items="supervisors"
                                  item-value="id"
                                  item-text="email"
                                  label="Opiekun firmy"
                              >
                                <template v-slot:selection="data">
                                  {{ data.item.name }} {{ data.item.surname }} - {{ data.item.email }}
                                </template>
                                <template v-slot:item="data">
                                  {{ data.item.name }} {{ data.item.surname }} - {{ data.item.email }}
                                </template>
                              </v-autocomplete>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer />
                              <v-btn
                                  @click="saveCompanyDetails"
                              >
                                Zapisz
                                <v-icon size="24" right>
                                  mdi-content-save-outline
                                </v-icon>
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                          <v-card class="mb-2">
                            <v-card-title>
                              Użytkownicy
                            </v-card-title>
                            <v-card-text>
                              <CompanyUsersDetails
                                  :id="this.id"
                              ></CompanyUsersDetails>
                            </v-card-text>
                          </v-card>
                          <v-card class="mb-2">
                            <v-card-title>
                              Wyślij e-mail do firmy
                            </v-card-title>
                            <v-card-text>
                              <!-- To get all available templates set :templates-to-list="[]". -->
                              <!-- To make the field empty set :templates-to-list="['']". -->
                              <v-autocomplete
                                  v-model="sendEmailUser"
                                  :items="users"
                                  item-value="id"
                                  item-text="email"
                                  label="Użytkownik"
                              >
                                <template v-slot:selection="data">
                                  {{ data.item.email }} {{ data.item.info }}
                                </template>
                                <template v-slot:item="data">
                                  {{ data.item.email }} {{ data.item.info }}
                                </template>
                              </v-autocomplete>
                              <SendEmail
                                  v-if="isAdmin() || isTrader()"
                                  :receiver-entity-id="sendEmailUser"
                                  receiver-entity-name="User"
                                  :disabled=!sendEmailUser
                                  :templates-to-list="[
                                    'account-activation-documents-details-mismatch',
                                    'account-activation-documents-unreadable',
                                    'account-activation-email-mismatch',
                                    'account-activation-no-transfer',
                                    'account-activation-transfer-details-mismatch',
                                    'account-activation-waiting',
                                    'account-premium-activation-confirmed',
                                    'company-details-updated',
                                    'transfer-refund',
                                    'emitter-add-new-sale-offer',
                                    'natural-person-add-new-sale-offer',
                                    'natural-person-waste-algorithm',
                                    'collector-buy-with-waste-master',
                                    'collector-add-sale-offer',
                                  ]"
                              ></SendEmail>
                            </v-card-text>
                          </v-card>
                          <v-card class="mb-2">
                            <v-card-title>
                              Wyślij SMS
                            </v-card-title>
                            <v-card-text>
                              <!-- To get all available templates set :templates-to-list="[]". -->
                              <!-- To make the field empty set :templates-to-list="['']". -->
                              <v-autocomplete
                                  v-model="sendSmsUser"
                                  :items="users.filter(user => user.phone)"
                                  item-value="id"
                                  item-text="email"
                                  label="Użytkownik"
                              >
                                <template v-slot:selection="data">
                                  {{ data.item.email }} - {{ data.item.phone }} {{ data.item.info }}
                                </template>
                                <template v-slot:item="data">
                                  {{ data.item.email }} - {{ data.item.phone }} {{ data.item.info }}
                                </template>
                              </v-autocomplete>
                              <SendSms :user-id="sendSmsUser"></SendSms>
                            </v-card-text>
                          </v-card>
                          <v-card>
                            <v-card-title>
                              Notatki
                            </v-card-title>
                            <v-card-text>
                              <Notes
                                  :id="this.id"
                                  url-add="/api/companies/{parentId}/notes"
                                  url-delete="/api/companies/{parentId}/notes/{id}"
                                  url-update="/api/companies/{parentId}/notes/{id}"
                                  url-list="/api/companies/{parentId}/notes"
                              ></Notes>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card>
                            <v-card-title>
                              Oferty sprzedaży
                            </v-card-title>
                            <v-card-text>
                              <CompanySaleOffers
                                  :id="this.id"
                              ></CompanySaleOffers>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card>
                            <v-card-text>
                              <company-categories
                                  :id="this.id"
                              ></company-categories>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card>
                            <v-card-title>
                              Obsługiwane kody odpadów
                            </v-card-title>
                            <v-card-text>
                              <CompanyWasteCodes
                                  :id="this.id"
                              ></CompanyWasteCodes>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card>
                            <v-card-title>Wysłane wiadomości</v-card-title>
                            <v-card-subtitle class="font-weight-bold">Wysłane wiadomości do użytkowników firmy</v-card-subtitle>
                            <v-card-text>
                              <data-table
                                  :headers="messagesTableHeaders"
                                  :items="companyDetails.messages"
                                  :server-items-length="companyDetails.messages.length"
                                  :loading="loading"
                                  class="row-pointer"
                              >
                                <template v-slot:item.body="{ item }">
                                  {{ item.type == 'email' ? item.subject : item.body }}
                                  <v-dialog
                                      v-model="dialog"
                                      width="720px"
                                      scrollable
                                  >
                                    <template v-if="item.type == 'email'" v-slot:activator="{ on, attrs }">
                                      <v-btn
                                          class="mx-2"
                                          v-bind="attrs"
                                          v-on="on"
                                      >
                                        Treść
                                      </v-btn>
                                    </template>

                                    <v-card>
                                      <v-card-text v-html="item.body"></v-card-text>
                                    </v-card>
                                  </v-dialog>
                                </template>
                                <template v-slot:item.createdAt="{ item }">
                                  {{ localDateTime(item.createdAt) }}
                                </template>
                                <template v-slot:item.id="{ item }">
                                  <v-btn
                                      class="mx-2"
                                      @click="sendMessage(item.id)"
                                  >
                                    Wyślij ponownie
                                  </v-btn>
                                </template>
                              </data-table>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card>
                            <v-card-title>Dokumenty</v-card-title>
                            <v-card-subtitle class="font-weight-bold">Załączniki</v-card-subtitle>
                            <v-card-text v-if="packs.length">
                              <div v-for="(pack, i) in packs" :key="i">
                                <div>
                                  Paczka dokumentów ID {{pack.id}}<br />{{ pack.notes }}
                                </div>
                                <div class="mt-2">
                                  <div v-for="document in pack.documents" :key="document.id">
                                    <div>
                                      <v-icon v-if="'application/pdf' === document.mimeType">mdi-file-pdf</v-icon>
                                      <v-icon v-else>mdi-file-image</v-icon>
                                      <a :href="document.url">
                                        {{ document.filename }} ({{ humanFileSizeFormat(document.fileSize) }})
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </v-card-text>
                            <v-card-text v-else>
                              Brak
                            </v-card-text>
                            <v-card-subtitle class="font-weight-bold">Podgląd zdjęć</v-card-subtitle>
                            <v-card-text v-if="photos.length">
                              <div style="width: 10%;">
                                <ImagesPreview :images="photos" />
                              </div>
                            </v-card-text>
                            <v-card-text v-else>
                              Brak
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-card-text class="text-center">
                        <v-btn
                            v-if="'Y' === this.rawCompanyDetails.confirmed"
                            class="mx-3"
                            @click="withdrawConfirmation"
                            color="red lighten-1"
                        >
                            Cofnij potwierdzenie
                        </v-btn>
                        <v-btn
                            v-if="'P' === this.rawCompanyDetails.confirmed"
                            class="mx-3"
                            @click="withdrawConfirmation"
                            color="red lighten-1"
                        >
                          Oznacz jako niepotwierdzona
                        </v-btn>
                        <v-btn
                            v-if="'Y' !== this.rawCompanyDetails.confirmed"
                            class="mx-3"
                            @click="confirm"
                            color="green lighten-1 white--text"
                        >
                            Potwierdź firmę
                        </v-btn>
                        <v-tooltip
                            :disabled="!!companyDetails.email"
                            top
                        >
                          <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <v-btn
                                  v-if="'Y' !== companyDetails.confirmed"
                                  class="mx-3"
                                  @click="sendCode"
                                  color="blue blue-1 white--text"
                                  :disabled="codeBeingSend || !companyDetails.email"
                              >
                                Wyślij kod potwierdzający
                              </v-btn>
                            </span>
                          </template>
                          <span>
                            Nie można wysłać kodu ponieważ firma nie podała oficjalnego adresu email,
                            na który mielibyśmy wysłać taki kod.
                          </span>
                        </v-tooltip>
                    </v-card-text>
                </v-col>
            </v-row>
        </v-container>
        <Loader :loading="loading" />
    </div>
</template>

<script>
    import api from '../services/api';
    import ImagesPreview from '../components/ImagesPreview';
    import humanFileSize from '../mixins/humanFileSize';
    import Loader from '../components/Loader';
    import Notes from "@/components/notes/Notes";
    import CompanySaleOffers from "@/components/CompanySaleOffers";
    import CompanyUsersDetails from '../components/CompanyUsersDetails';
    import SendEmail from '../components/SendEmail';
    import permissions from "@/mixins/permissions";
    import { getItems as getCompanyStatusItems } from '@/enums/CompanyStatus';
    import { getItems as getCompanyTypeItems } from '@/enums/CompanyType';
    import CompanyWasteCodes from "../components/CompanyWasteCodes";
    import CompanyCategories from "@/components/CompanyCategories.vue";
    import SendSms from "@/components/SendSms.vue";
    import DataTable from "@/components/data-table/DataTable.vue";
    import formatters from "@/mixins/formatters";

    export default {
        components: {
          DataTable,
          SendSms,
          CompanyCategories,
            CompanyWasteCodes,
            CompanySaleOffers,
            CompanyUsersDetails,
            ImagesPreview,
            Loader,
            Notes,
            SendEmail,
        },
        mixins: [
            humanFileSize,
            permissions,
            formatters,
        ],
        props: ['id'],
        savedCompanyDetails: null,
        data() {
            return {
                tab: null,
                supervisors: [],
                users: [],
                sendEmailUser: null,
                sendSmsUser: null,
                types: getCompanyTypeItems(),
                statuses: getCompanyStatusItems(),
                regions: [
                    {
                      key: 'DS',
                      value: 'dolnośląskie'
                    },
                    {
                      key: 'KP',
                      value: 'kujawsko-pomorskie'
                    },
                    {
                      key: 'LB',
                      value: 'lubelskie'
                    },
                    {
                      key: 'LS',
                      value: 'lubuskie'
                    },
                    {
                      key: 'LD',
                      value: 'łódzkie'
                    },
                    {
                      key: 'MP',
                      value: 'małopolskie'
                    },
                    {
                      key: 'MZ',
                      value: 'mazowieckie'
                    },
                    {
                      key: 'OP',
                      value: 'opolskie'
                    },
                    {
                      key: 'PK',
                      value: 'podkarpackie'
                    },
                    {
                      key: 'PL',
                      value: 'podlaskie'
                    },
                    {
                      key: 'PM',
                      value: 'pomorskie'
                    },
                    {
                      key: 'ŚL',
                      value: 'śląskie'
                    },
                    {
                      key: 'SK',
                      value: 'świętokrzyskie'
                    },
                    {
                      key: 'WM',
                      value: 'warmińsko-mazurskie'
                    },
                    {
                      key: 'WP',
                      value: 'wielkopolskie'
                    },
                    {
                      key: 'ZP',
                      value: 'zachodniopomorskie'
                    }
                ],
                rules: {
                    nip: [
                        (value) => {
                            if (typeof value === 'string' && value.length && value.length !== 10) {
                                return 'Wpisz prawidłowy numer NIP.';
                            }

                            return true;
                        },
                    ],
                    email: [
                        (value) => {
                            if (typeof value === 'string' && !this.validateEmail(value)) {
                                return 'Wpisz poprawny adres e-mail.';
                            }

                            return true;
                        },
                    ],
                    bdo: [
                        (value) => {
                            if (null === value) {
                                return true;
                            }

                            return (
                                (typeof value === 'string' && value.length < 20) ||
                                'Numer BDO nie może mieć więcej niż 20 znaków.'
                            );
                        },
                    ],
                },
                loadingDetails: false,
                rawCompanyDetails: [],
                packs: [],
                photos: [],
                loading: false,
                codeBeingSend: false,
                messagesTableHeaders: [
                  {text: 'Wiadomość', value: 'body', sortable: false, width: "80%"},
                  {text: 'Typ', value: 'type', sortable: false},
                  {text: 'Użytkownik', value: 'email', sortable: false},
                  {text: 'Data', value: 'createdAt', sortable: false},
                  {text: 'Wyślij', value: 'id', sortable: false},
                ],
            }
        },
        computed: {
            companyDetails() {
                let address = this.rawCompanyDetails
                    ? this.rawCompanyDetails.address
                    : null;

                if (!address) {
                    // Warning: From API's point of view NULL-s here means "do not update this field".
                    address = {
                        address: null, // Street and numbers.
                        city: null,
                        postalCode: null,
                        region: null,
                        country: null,
                    };
                }

                let points = this.rawCompanyDetails.points;

                // Warning: From API's point of view selectedIds that evaluates to false means "do not update this field".

                return {
                    type: this.rawCompanyDetails.type || null,
                    name: this.rawCompanyDetails.name || null,
                    nip: this.rawCompanyDetails.nip || null,
                    email: this.rawCompanyDetails.email || null, // Official email address.
                    address,
                    rating: this.rawCompanyDetails.rating || null,
                    bdo: this.rawCompanyDetails.bdo || null,
                    confirmed: this.rawCompanyDetails.confirmed,
                    premium: this.rawCompanyDetails.premium || false,
                    bdoSubscription: this.rawCompanyDetails.bdoSubscription || false,
                    active: this.rawCompanyDetails.active || false,
                    partner: this.rawCompanyDetails.partner || false,
                    points: points ? points.quantity + 0 : null,
                    plcId: this.rawCompanyDetails.plcId || null,
                    messages: this.rawCompanyDetails.messages || [],
                    supervisor: typeof this.rawCompanyDetails.supervisor === 'object' && this.rawCompanyDetails.supervisor !== null? this.rawCompanyDetails.supervisor.id : this.rawCompanyDetails.supervisor,
                };
            },
        },
        methods: {
            async loadSupervisors() {
                const supervisorsResponse = await api.get(`/api/users?role=ROLE_SUPERVISOR`);
                this.supervisors = [{id: 0, email: "Wybierz opiekuna"}].concat(supervisorsResponse.data.items)
            },
            async loadDetails() {
                this.loadingDetails = true;

                let response;

                try {
                    response = await api.get(`/api/companies/${this.id}?includeMessages=true`);
                } catch (error) {
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się wczytać danych firmy.',
                        error,
                    });

                    return;
                }

                this.loadingDetails = false;

                this.rawCompanyDetails = response.data;
                this.savedCompanyDetails = JSON.parse(JSON.stringify(this.companyDetails));
            },
            async loadPhotos() {
                const companyDocumentsResponse = await api.get(`/api/companies/${this.id}/documents-packs`);
                const packs = companyDocumentsResponse.data;

                packs.forEach((pack) => {
                    pack.documents.forEach(document => {
                        this.photos.push(document.url);
                    });
                });

                this.packs = packs;
            },
            async changeConfirmationStatus(status, messageOnError) {
                this.loading = true;
                api.put(
                    `/api/companies/${this.id}/confirm`,
                    {confirmed: status}
                ).then((response) => {
                    this.rawCompanyDetails.confirmed = response.data.confirmed;
                    this.savedCompanyDetails = JSON.parse(JSON.stringify(this.companyDetails));
                }).catch((error) => {
                    this.$root.$emit('notifyError', {
                        html: messageOnError,
                        error
                    });
                }).finally(() => {
                    this.loading = false;
                });
            },
            withdrawConfirmation() {
                this.changeConfirmationStatus('N', 'Nie udało się wycofać potwierdzenia firmy.');
            },
            confirm() {
                this.changeConfirmationStatus('Y', 'Nie udało się potwierdzić firmy.');
            },
            sendCode() {
                this.codeBeingSend = true;

                const data = {
                    type: 'confirming',
                    // maxCompanies: 10, // May be changed from here. API will assume 10 by default.
                    email: this.companyDetails.email,
                };

                api.post(`/api/companies/${this.id}/send-code`, data)
                    .then((response) => {
                        this.$root.$emit('notifySuccess', {
                            html: `Wysłano kod potwierdzający: ${response.data.code}.`,
                        });
                    })
                    .catch((error) => {
                        this.$root.$emit('notifyError', {
                            html: 'Nie udało się wysłać kodu potwierdzającego.',
                            error,
                        });
                    })
                    .finally(() => {
                        this.codeBeingSend = false;
                    });
            },
            async saveCompanyDetails() {
                if (!this.$refs.companyDetailsForm.validate()) {
                    return;
                }

                // The following variable will contain only those fields that were modified.
                const dataToSave = this.getObjectDiff(this.companyDetails, this.savedCompanyDetails);

                if (!Object.keys(dataToSave).length) {
                    this.$root.$emit('notify', {
                        html: 'Nie ma nic nowego do zapisania.'
                    });

                    return;
                }

                this.loading = true;
                let response;

                try {
                    response = await api.put(`/api/companies/${this.id}`, dataToSave);
                } catch (error) {
                    /** @see https://github.com/axios/axios#handling-errors */
                    this.loading = false;
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się zapisać danych firmy.',
                        error
                    });

                    return;
                }

                const previouslySavedCompanyDetails = JSON.parse(JSON.stringify(this.savedCompanyDetails));
                this.rawCompanyDetails = response.data;
                this.savedCompanyDetails = JSON.parse(JSON.stringify(this.companyDetails));
                this.loading = false;
                this.$root.$emit('notifySuccess', {
                    html: 'Dane firmy zostały zapisane.'
                });

                if (!dataToSave.confirmed &&
                    previouslySavedCompanyDetails.confirmed !== this.savedCompanyDetails.confirmed
                ) {
                    // TODO: There is only one Snackbar, so we cannot emit this warning using it.
                    alert('Status potwierdzenia firmy uległ zmianie.');
                }
            },
            getObjectDiff(obj1, obj2) {
                const diffObject = {};

                for (const key of Object.keys(obj1)) {
                    if (obj1[key] instanceof Object) {
                        const nestedObj = this.getObjectDiff(obj1[key], obj2[key]);

                        if (Object.keys(nestedObj).length > 0) {
                            diffObject[key] = nestedObj;
                        }
                    } else if (obj1[key] !== obj2[key]) {
                        diffObject[key] = obj1[key];
                    }
                }

                return diffObject;
            },
          getUsers() {
            api.get(`/api/companies/${this.id}/users`, {})
                .then((response) => {
                  this.users = response.data.items;
                })
                .catch((error) => {
                  this.$root.$emit('notifyError', {
                    html: 'Nie udało się wczytać danych użytkowników.',
                    error,
                  });
                });
          },
          sendMessage(id) {
            api
                .post('/api/users/sendMessage/' + id, {})
                .then(() => {
                  this.$root.$emit('notifySuccess', {
                    html: 'Wiadomość została wysłana.',
                  });
                  this.loadDetails();
                })
                .catch((error) => {
                  console.error('Error when adding a dimension:', error);
                  this.$root.$emit('notifyError', {
                    html: 'Wystąpił błąd.',
                  });
                })
          },
          validateEmail(email) {
            const regex = /\S+@\S+\.\S+/;
            return regex.test(email);
          }
        },
        async created() {
            try {
                this.loadDetails();
                this.getUsers();
                this.loadPhotos();
                await this.loadSupervisors();
            } catch (e) {
                void(0);
            }
        }
    }
</script>

<style scoped>
    .v-data-table
    /deep/
    tbody
    /deep/
    tr:hover:not(.v-data-table__expanded__content) {
        background: #ffffff !important;
    }
</style>
<style>
.disabled-label {
    margin-top: -10px;
    height: 20px;
    line-height: 20px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.38);
}
</style>